import { SelectableWithIdObject } from "src/components/Form/types";

import { RoleShort } from "src/shared/api-types/role";
import request from "./request";

export class Role extends SelectableWithIdObject {
  public name: string;
  public code: string;

  constructor(data: RoleShort) {
    super(data.id);
    this.name = data.name;
    this.code = data.code;
  }

  getDisplayName(): string {
    return this.name;
  }
}

export const mapRole = (data: RoleShort): Role => {
  return new Role(data);
};

export const getRoles = async (): Promise<Role[]> => {
  const response = await request(`/roles`);
  return response.map((data: RoleShort) => mapRole(data));
};

export const getRolesByCrewId = async (crewId: number): Promise<Role[]> => {
  const response = await request(`/roles/crews/${crewId}`);
  return response.map((data: RoleShort) => mapRole(data));
};
